import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use this wizard to <strong>extend the expiration date</strong> of an active order, giving recipients more time to use their licenses." id="use_this_wizard_to_extend_the_expiration.3448063c" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Extending an Order" id="extending_an_order.762a6f8a" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Follow the guided steps to <strong>select the order</strong>, choose a new expiration date, and <strong>confirm</strong> the extension." id="follow_the_guided_steps_to_select_the_or.45ff287f" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Wizard Steps" id="wizard_steps.9ec5a8f5" />
        }
    ],
    title: <FormattedMessage defaultMessage="Extend Order" id="extend_order.007fe725" />
};
